// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amSfXWmFK6kpR1WHuKhh{flex-direction:column;gap:16px;display:flex}.knaamF51iBIWo5iBYRbQ{flex-direction:column;gap:4px;display:flex}.TFUn_M7RoU7pMYhSmPVA{margin-bottom:-4px}.MzxhXv5E0agJuAVHTAJU{align-items:center;width:84px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `amSfXWmFK6kpR1WHuKhh`,
	"wrapField": `knaamF51iBIWo5iBYRbQ`,
	"label": `TFUn_M7RoU7pMYhSmPVA`,
	"send": `MzxhXv5E0agJuAVHTAJU`
};
export default ___CSS_LOADER_EXPORT___;
